export var VERSION = '1.24.2';
//# sourceMappingURL=version.js.map